import { render, staticRenderFns } from "./tradeMassOderModal.vue?vue&type=template&id=b4199d7a&"
import script from "./tradeMassOderModal.vue?vue&type=script&lang=js&"
export * from "./tradeMassOderModal.vue?vue&type=script&lang=js&"
import style0 from "./tradeMassOderModal.vue?vue&type=style&index=0&id=b4199d7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports